$(document).ready(function() {
    $('.arrow-button').on('click', function() {
        if(!$(this).hasClass('collapsed') === $(this).hasClass('open')) {
            $(this).toggleClass('open');
        }
    });
});